module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CT",
    attrs: {
      "id": "_idParaDest-2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Title02"
  }, [_vm._v("M")]), _vm._v(" "), _c('p', {
    staticClass: "Title02"
  }, [_vm._v("A")]), _vm._v(" "), _c('p', {
    staticClass: "Title02"
  }, [_vm._v("G")]), _vm._v(" "), _c('p', {
    staticClass: "Title02"
  }, [_vm._v("M")]), _vm._v(" "), _c('p', {
    staticClass: "Title02"
  }, [_vm._v("A")]), _vm._v(" "), _c('p', {
    staticClass: "Author01"
  }, [_vm._v("THÓRA HJÖRLEIFSDÓTTIR")]), _vm._v(" "), _c('p', {
    staticClass: "Author ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  }, [_vm._v("Translated from the Icelandic by")])]), _vm._v(" "), _c('p', {
    staticClass: "Author ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  }, [_vm._v("Meg Matich")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/BlackCat.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-3"
  }, [_vm._v("Black Cat")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-4"
  }, [_c('span', {
    staticClass: "CharOverride-4"
  }, [_vm._v("New York")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-435e130d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802157409-1.vue
// module id = 66
// module chunks = 0